/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

export const DEFAULT_MAX_RECENT_API_CALLS = 5;

export const DEFAULT_MAX_API_CALL_ENTRY_BYTES = 4 * 1024;

export const REGISTRATION_KIND_BASE = 'base';

export const REGISTRATION_KIND_OVERLAY = 'overlay';

export const EXCLUDED_API_CALL_NAMES = new Set(['command-cloud-ai', 'cds-ai-service', 'ai']);

export const EXCLUDED_API_CALL_PATH_FRAGMENTS = ['/chat-channels', '/agent-chat', '/agent-workflow'];
